import { HttpContextToken } from "@angular/common/http";

export const SKIP_LOGGING_ON_FAILURE = new HttpContextToken(() => false);